import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../../core/common/imageWithBasePath";
import CommonSelectV2 from "../../../../core/common/commonSelectV2";
import FormFooter from "../../../../core/common/formFooter";


export interface DropDownProps {
  dropDownItems: any,
  dropDownLable: string
  dropDownDefault?: any
}

const customComponents = {
  Option: (props: any) => (
    <div {...props.innerProps} ref={props.innerRef} style={props.isFocused ? { backgroundColor: '#f0f0f0' } : {}}>
      <div className="p-2">
        <h6>
          {props.data.label}
          <span className={`ms-2 badge rounded-pill bg-light`}>
            {props.data.value}
          </span>
        </h6>
      </div>
    </div>
  ),
  // You can add more custom components here if needed
};

const formatOptionLabel = (option: any) => (
  <div className="pt-1">
    <h6>
      {option.label}
      <span className={`ms-2 badge rounded-pill bg-light`}>
        {option.value}
      </span>
    </h6>
  </div>
);

export interface MsgBoxProps {
  message: string
  error: boolean
  success?: boolean
}

interface Props {
  msgBoxProps?: MsgBoxProps
  heading: string
  dropDownParent: DropDownProps
  dropDownChild: DropDownProps
  onSave : (valPrnt:any, valChild:any)=>void
}

const AcadmicWizModal = ({heading, dropDownParent, dropDownChild, onSave, msgBoxProps}:Props) => {
  const [parentDD, setParentDD] = useState<DropDownProps>();
  const [childDD, setChildDD] = useState<DropDownProps>();
  const [messageProps, setMessageProps] = useState<MsgBoxProps>()

  const [selectedParentDD, setSelectedParentDD] = useState();
  const [selectedChildDD, setSelectedChildDD] = useState();

  useEffect(()=>{
    setMessageProps(msgBoxProps)
  },[msgBoxProps])

  useEffect(()=>{
    if(parentDD?.dropDownDefault?.value){
      setSelectedParentDD(parentDD?.dropDownDefault?.value)
    }
  },[parentDD?.dropDownDefault])

  

  const onCancel = () => {
    setSelectedParentDD(undefined)
    setSelectedChildDD(undefined)
    setMessageProps({
      message:"",
      error:false,
      success:false
    })
  }

  useEffect(()=>{
    setParentDD(dropDownParent)
  },[dropDownParent])

  useEffect(()=>{
    setChildDD(dropDownChild)
  },[dropDownChild])

  return (
    <div>

      {/* Add Todo */}
      <div className="modal fade" id="add_todo" aria-hidden="false">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{heading}</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={onCancel}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">{parentDD?.dropDownLable}</label>
                      <CommonSelectV2
                        onChange={(value)=>{
                          setSelectedParentDD(value)
                        }}
                        className="select"
                        options={parentDD?.dropDownItems}
                        defaultValue={parentDD?.dropDownDefault}
                        value={selectedParentDD ? parentDD?.dropDownItems.find((item:any)=>item?.value === selectedParentDD) : undefined}
                        components={customComponents}
                        formatOptionLabel={formatOptionLabel}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="mb-0">
                      <label className="form-label">{childDD?.dropDownLable}</label>
                      <CommonSelectV2
                        onChange={(value)=>{
                            setSelectedChildDD(value)
                        }}
                        className="select"
                        defaultValue={undefined}
                        options={childDD?.dropDownItems}
                        value={selectedChildDD ? childDD?.dropDownItems.find((item:any)=>item?.value === selectedChildDD) : undefined}
                        components={customComponents}
                        formatOptionLabel={formatOptionLabel}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
               <FormFooter 
                onCancel={onCancel} 
                onSave={(e:any)=>{
                  e.preventDefault()
                  onSave(selectedParentDD, selectedChildDD)
                }}
                message={messageProps?.message}
                error={messageProps?.error}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Todo */}

      {/* Delete Note */}
      <div className="modal fade" id="delete-note-units">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="delete-popup">
                  <div className="delete-image text-center mx-auto">
                    <ImageWithBasePath
                      src="./assets/img/icons/close-circle.png"
                      alt="Img"
                      className="img-fluid"
                    />
                  </div>
                  <div className="delete-heads">
                    <h4>Are You Sure?</h4>
                    <p>
                      Do you really want to delete this item, This process
                      cannot be undone, confirm.
                    </p>
                  </div>
                  <div className="modal-footer-btn delete-footer">
                    <Link
                      to="#"
                      className="btn btn-cancel me-2"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Link to="#" className="btn btn-submit">
                      Delete
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Note */}

    </div>
  );
};

export default AcadmicWizModal;
